export default __webpack_public_path__ + "static/media/Marktcharts.19c368fa.jpg";